import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';



export default {
  name: 'LostRecoverySummary',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate : '',
        toDate:'',
        searchflag:false,
        pagecount: 0,
        pageno: 1,
        totalRecords:0,
        userDataKey : '',
        userList: [
            {}
        ],
        status:'0',
        debitids:[],
        loaderBtn:false,
        Loading:false,
        isShow:false,
        allLedgerDetails:{},
        expandedIndex: null,
        allShipmentDetails:{},
        submit:false,
        arrowCls:false,
        arrowIndex:'',
        shipmentClosedCount:'',
        debitFrom:'',
        awbnumbers:''
      }
  },
  created: function() {
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    
  },
  methods : {
     getLostRecoveryData(){
      console.log("hii")
      this.submit=true;
       console.log(this.fromDate, this.toDate)
       if(this.debitids!=''){
          var debitIds = this.debitids.split(",");
       }else{
        debitIds=[];
       }
        console.log("hkhsfkjhd", debitIds )
       if (this.awbnumbers!="") {
        var shippingIds=this.awbnumbers.split(",");
        this.pageno=1;
        }else{
          shippingIds=[];
        }
        if(shippingIds.length > 100){
              this.$alertify.error("Maximum 100 shippingID you can enter.")
        }
        // let shipmentReqArray = [];
        // $.each(shippingId, (key,shipmentId)=>{
        //   if(shipmentId != ''){
        //     shipmentReqArray.push(shipmentId.trim())
        //   }
        //   if(shipmentReqArray.length > 100){
        //     this.$alertify.error("Maximum 100 shippingID you can enter.")
        //   }
        // })
      
       if( debitIds.length!=0|| this.debitFrom!="" || (this.toDate!='' && this.fromDate!='' && this.status!='0' && this.toDate >= this.fromDate) ){
        this.Loading = true;
         this.searchDashboardCount = true;
         var pageNum=this.pageno - 1;
         console.log("pageNumber", this.debitids)
         axios({
           method: "POST",
           url:  apiUrl.api_url + 'lostrecovery/summary/allledgers',
           data: {
             "fromDate" : this.fromDate,
             "toDate" : this.toDate,
             "status": this.status,
             "debitids": debitIds,
             "shippingids":shippingIds,
             "debitfromtype":this.debitFrom?this.debitFrom:null,
             "offset" : pageNum,
             "limit" : 20,
           }
         }).then((response) => {
                this.isShow=true;
                var responseData=response.data.allLedgers.allLedgersGroupedByLedgerid;
                this.allLedgerDetails=responseData;
                // let totalRecoveredAmt=0;
                for (let key in this.allLedgerDetails) {
                  let totalRecoveredAmt=0;
                  for (let i = 0; i < this.allLedgerDetails[key].length; i++) {
                      const entry = this.allLedgerDetails[key][i];
                      let totaldueamount=entry.totaldueamount?entry.totaldueamount:0.00;
                      let recoverydebitamount=entry.recoverydebitamount?entry.recoverydebitamount:0.00;
                      let openingAmt=parseFloat(totaldueamount)-parseFloat(recoverydebitamount)
                      entry.openingAmount=openingAmt.toFixed(2)
                      let RecoveredAmount=entry.RecoveredAmount?entry.RecoveredAmount:0.00;
                       totalRecoveredAmt=totalRecoveredAmt+parseFloat(RecoveredAmount);
                  }
                  // console.log("popopdopsodpsdopsodpso", totalRecoveredAmt)
                  let totalRecoverdCalculated=parseFloat(totalRecoveredAmt)
                  this.allLedgerDetails[key].totalRecoverdCalculated=totalRecoverdCalculated.toFixed(2)
              }
                let totalRows = response.data.allLedgers.totalCount;
                this.totalRecords = totalRows
                console.log("Rowsssss", this.allLedgerDetails)
               if (totalRows < 20) {
                   this.pagecount = 1;
                   console.log("pagecountIffffff",  this.pagecount)
               } else {
                   this.pagecount = Math.ceil(totalRows / 20)
                   console.log("pagecountElse",  this.pagecount)
               }
               this.Loading = false;             
          })
          .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
          })
       }
       else {
        if(this.toDate <= this.fromDate ){
          this.$alertify.error("To Date is greter than from Date");
        }
       }
     },

    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        console.log("rezulte", result)
        if (result) {
          this.fromDate = this.fromDate;
          this.toDate = this.toDate;
          this.getLostRecoveryData();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getPaginationData(pageNum) {
        this.pageno = pageNum;
        console.log(pageNum)
        this.getLostRecoveryData();
    },
    clear(){
      this.fromDate = '';
      this.toDate = '';
      this.status='0';
      this.submit=false;
      this.debitFrom= '';
      this.debitids='';
      this.awbnumbers='';
      this.$validator.reset();
      this.errors.clear();
      this.isShow=false;
      this.pagecount = 0;
      this.pageno = 1;
      this.allLedgerDetails={};
      this.allShipmentDetails={};
    },
    ledgerShipmentdata(id){
      this.loaderBtn = true;
      this.allShipmentDetails=[];
      let payload={
          ledgerid:id.toString(),
       }
       console.log(payload);
      axios.post(apiUrl.api_url + 'lostrecovery/summary/allledgershipments',payload)
        .then((response) => {
          console.log("==>>>>>>>", response.data)
          if(response.data.code ===202){
            this.allShipmentDetails=response.data.allShipmentDetails || [];
            this.loaderBtn = false;
            // var count=0;
            // var allShipments=this.allShipmentDetails;
            // allShipments.forEach(element => {
            //   if(element.Status!="PartialDebit"){
            //     count++;
            //   }
            // });
            // this.shipmentClosedCount=count;
          }else if(response.data.code === 204){
            this.loaderBtn=false;
            this.allShipmentDetails=[]
            this.$alertify.error(response.data.msg);

          }
        })
      .catch((httpException) => {
          console.error('exception is:::::::::',httpException)
      });
    },


     toggleRow(index, id) {
      console.log(index, id,"=====>>>>>>>>>>>>>>>>>>>>>>>>>>")
      this.arrowCls=!this.arrowCls;
      this.arrowIndex=id;
      this.ledgerShipmentdata(id);
      this.expandedIndex = this.expandedIndex === index ? null : index;
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment.utc(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/LostRecoverySummary/LostRecoverySummary.component.js